import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EventEmitter from '@utility/eventSubscribers';
import cardProcessingGiff from '@assets/JSON_Files/CreditCardProcessing.json';
import LazyLottieLoader from '../../utility/lazyLottieLoader';
import tapDetectedGif from '@assets/images/payment/3-TapDetected.gif';
import tapOrInsert1 from '@assets/images/payment/tapCard.gif';
import tapOrInsert2 from '@assets/JSON_Files/Insert_Debit_Card.json';
import tapOrInsert3 from '@assets/images/payment/swipeCard.gif';
import { setNotification } from '@reducers/notification';
import { disableFooter } from '@reducers/orders';
import { bindActionCreators } from 'redux';
import { flowType } from '@utility/userInfo';
import cn from 'classnames';
import { urlSearchParams } from '../../utility/utills';


const Pay = ({ ...props }) => {
  const {
    serverAppTheme,
    handleFailureRoute,
  } = props;
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const isServerApp = flowType() === 'serverApp';
  
  const returnProcess = () => {
    return tapOrInsert2;
  };
  const tapDetected = () => {
    return tapDetectedGif;
  }
  const cardProcessing = () => {
    return cardProcessingGiff;
    // return  <Lottie animationData={swipeGiftCard} loop={true} autoplay={true} speed={1} />
  }

 
  const returnErrorRotated = () => {
    return tapOrInsert1;
  };
  const responseArray = [];

  const creditSaleListener = (response) => {
    // clearInterval(timerInterval)
    switch (response.code) {
      case 'LOGIN_TO_GATEWAY': {
        responseArray.push(response.code);
        // <Lottie animationData={swipeGiftCard} loop={true} autoplay={true} speed={1} />
        setImage(cardProcessingGiff)
        setState({ screenName: 'LOGGING_INTO_GATEWAY', displayName: 'Logging into Gateway' });
        break;
      }
      case 'INSERT_TAP_SWIPE_CARD': {
        responseArray.push(response.code);
        setImage(tapOrInsert2);
        setState({ screenName: 'INSERT_CARD', displayName: 'TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY' });
        break;
      }
      case 'TAP_SWIPE_CARD':
      case 'WAITING_FOR_SWIPE': {
        responseArray.push(response.code);
        setImage(tapOrInsert2);
        setState({ screenName: 'INSERT_CARD', displayName: 'Swipe Card' });
        break;
      }
      case 'SWIPE_CARD': {
        responseArray.push(response.code);
        setImage(tapOrInsert3);
        setState({ screenName: 'INSERT_CARD', displayName: 'Swipe Card' });
        break;
      }
      case 'SWIPE_DETECTED': {
        responseArray.push(response.code);
        setImage(tapOrInsert3);
        setState({
          screenName: 'PAYMENT_PROCESSING',
          method: 'CARDMETHOD.SWIPE',
          mode: 'MODE.CARD',
          displayName: 'Payment Processing'
        });
        break;
      }
      case 'TAP_DETECTED': {
        responseArray.push(response.code);
        setImage(tapDetected());
        setState({
          screenName: 'PAYMENT_PROCESSING',
          method: 'CARDMETHOD.TAP',
          mode: 'MODE.NFC',
          displayName: 'Tap Detected'
        });
        break;
      }
      case 'CARD_INSERTED': {
        responseArray.push(response.code);
        setImage(returnProcess());
        console.log('returnP',returnProcess());
        setState({
          screenName: 'PAYMENT_PROCESSING',
          method: 'CARDMETHOD.INSERT',
          mode: 'MODE.CARD',
          displayName: 'Card Inserted'
        });
        break;
      }
      case 'REMOVE_CARD': {
        responseArray.push(response.code);
        setImage(returnProcess());
        setState({
          screenName: 'COMPLETED',
          displayName: 'Completed'
        });
        break;
      }
      case 'APPLICATION_SELECTION_COMPLETED': {
        responseArray.push(response.code);
        break;
      }
      case 'GETTING_ONLINE_AUTHORIZATION': {
        responseArray.push(response.code);
        break;
      }
      case 'UPDATING_TRANSACTION': {
        responseArray.push(response.code);
        setImage(cardProcessing());
        setState({
          screenName: 'UPDATING_TRANSACTION',
          message: response.message,
          displayName: 'Processing'
        });
        break;
      }
      case 'GETTING_CARD_VERIFICATION': {
        responseArray.push(response.code);
        break;
      }
      case 'RESWIPE_CARD': {
        responseArray.push(response.code);
        setState({
          screenName: 'INSERT_CARD',
          message: response.message,
          displayName: 'Insert Card'
        });
        break;
      }
      case 'REINSERT_CARD': {
        responseArray.push(response.code);
        setState({
          screenName: 'INSERT_CARD',
          message: response.message,
          displayName: 'Reinsert Card'
        });
        break;
      }
      case 'SWIPE_NOT_ALLOWED': {
        responseArray.push(response.code);
        setState({
          screenName: 'SWIPE_NOT_ALLOWED',
          message: response.message,
          displayName: 'Swipe Not Allowed'
        });
        break;
      }
      case 'CHIP_CARD_SWIPE_FAILED': {
        responseArray.push(response.code);
        setState({ screenName: 'INSERT_CARD', message: response.message });
        break;
      }
      case 'UNKNOWN_RESPONSE': {
        responseArray.push(response.code);
        setState({ screenName: 'INSERT_CARD', message: response.message });
        break;
      }
      case 'CONTACTLESS_INTERFACE_FAILED': {
        responseArray.push(response.code);
        setImage(returnErrorRotated());
        setState({ screenName: 'INSERT_CARD', message: response.message });
        break;
      }
      case 'MULTIPLE_CONTACTLESS_CARDS_DETECTED': {
        responseArray.push(response.code);
        setImage(returnErrorRotated());
        setState({ screenName: 'MULTIPLE_CONTACTLESS_CARDS_DETECTED', message: response.message });
        break;
      }
      case 'ERROR_READING_CONTACTLESS_CARD':
        responseArray.push(response.code);
        setState({ screenName: 'INSERT_CARD', displayName: 'ERROR READING CONTACTLESS CARD - TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY' });
        break;
      case 'INVALID_INPUT':
        responseArray.push(response.code);
        setState({
          screenName: 'INVALID_INPUT',
          message: response.message,
          displayName: 'Invalid input'
        });
        break;
      case 'DEVICE_ERROR':
        responseArray.push(response.code);
        setState({
          screenName: 'INSERT_CARD',
          message: response.message,
          displayName: 'Device error'
        });
        break;
      case 'APPLICATION_SELECTION_NOT_SUPPORTED':
        responseArray.push(response.code);
        setState({
          screenName: 'INSERT_CARD',
          message: response.message,
          displayName: 'Application selection not supported'
        });
        break;
      default: {
        console.info('payment code not handled', response.code, response.message);
      }
    }

  };

  const creditSaleSuccessListener = (message) => {
    setLoading(false);
  };

  const failureListener = (err) => {
    handleFailureRoute(err, responseArray, urlSearchParams('preAuth'));
  };

  useEffect(() => {
    if (urlSearchParams('preAuth')) {
      if (window.ReactNativeWebView) {
        EventEmitter.onProcessCreditTokenize(creditSaleListener);
        EventEmitter.onSuccessCreditTokenize(creditSaleSuccessListener);
        EventEmitter.onErrorCreditTokenize(failureListener);
      }
    } else {

      if(isServerApp){
        EventEmitter.processCredit(creditSaleListener);
        EventEmitter.processPayment(creditSaleSuccessListener, creditSaleListener ,failureListener);
      }
      else {
        EventEmitter.processCreditSale(creditSaleSuccessListener, failureListener);
      }

    }
    return () => {
      if (window.ReactNativeWebView) {
        EventEmitter.removeListeners('processPayment', creditSaleListener);
      }
    };
  }, []);


  useEffect(() => {
    setLoading(true);
  }, []);
  return (
    <div
      className="col-12 col-md-12 px-0 h-100"
      style={{
        background: serverAppTheme?.background_color,
        color: serverAppTheme?.primary_text,
      }}
    >
      {["kiosk"].includes(flowType()) ? (
        <span></span>
      ) : (
        // <div className="row h-100 w-100 align-items-center justify-content-center">
        //   <div className="col-12 d-flex align-items-center justify-content-center fs-40">
        //     { state && state.displayName === 'TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY'
        //       ? (
        //         <span>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">TAP OR INSERT CARD</div>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">OR</div>
        //           <div className="fs-24 fw-600 od-text-primary text-primary text-center">TAP PHONE FOR APPLE/GOOGLE PAY</div>
        //         </span>)
        //       : state.displayName}
        //   </div>
        //   <div className={`col-12 d-flex align-items-center justify-content-center ${style.rotate}`}>
        //     <img src={image} alt="" />
        //   </div>
        // </div>
        <>
          <div className="col-12 p-0 h-100 row mx-0 px-0 text-center">
            <div
              style={{
                backgroundColor: "transparent",
                left: "16px",
                border: "none",
              }}
              className={cn(
                "col-12 px-0 row w-100 justify-content-center align-items-center",
                state.displayName ===
                  "TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY"
                  ? "h-82"
                  : "h-65",
                "col-12 px-0",
              )}
            >
              {typeof image === "object" && (
                  <LazyLottieLoader
                    animationData={image}
                    loop={true}
                    autoplay={true}
                    speed={1}
                    style={{ width: "100%", height: "100%", border: "none" }}
                  />
              )}
            </div>
            {state.displayName ===
              "TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY" ? (
              <div className={cn("fs-24 fw-600 text-center h-12 col-12")}>
                {isServerApp ? (
                  <div className="fs-20 mx-auto w-70 px-0 d-flex justify-content-center align-items-center fw-600 text-center">
                    TAP OR INSERT CARD OR TAP PHONE FOR APPLE/GOOGLE PAY
                  </div>
                ) : (
                  <>
                    <div className="fs-24 fw-600  text-center">
                      TAP OR INSERT CARD
                    </div>
                    <div className="fs-24 fw-600 d-flex justify-content-center align-items-center text-center">
                      OR
                    </div>
                    <div className="fs-24 fw-600 d-flex justify-content-center align-items-center text-center">
                      TAP PHONE FOR APPLE/GOOGLE PAY
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="col-12 h-35 px-0">
                <div className={cn("fs_28 fw-600 h-75 col-12")}>
                  {state.displayName}
                </div>
              </div>
            )}
          </div>
          {/* <div className="col-12 p-0 h-60 row mx-0 justify-content-center align-items-end">
            <button
              type="button"
              className="btn70 od-btn-primary btn-primary btn-ripple mb-2 w-100 roundedLg"
          // onClick={processCreditSale}
              disabled={loading}
            >
              <div className="fs-18">{!loading ? 'Pay By Credit Card' : 'Payment Processing...' }</div>
            </button>
          </div> */}
        </>
      )}
    </div>
  );
};

const mapStateToProps = ({
  storeChecks, oauth, storeInfo, payment, theme, orders,
}) => ({
  storeCheckList: storeChecks.storeChecksList,
  authResponse: payment.authResponse,
  userInfo: oauth.loggedInUserData,
  serverAppTheme: theme.serverAppTheme,
  seat: orders.seats,
  storeInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setNotification,
  disableFooter
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pay);
